

export default function OptionInput({ option, setOption, label }) {

    const changeHandler = (e) => {
        setOption((prev) => {
            if (e.target.name === "isCorrect") {
                return {
                    ...prev,
                    isCorrect: e.target.checked,
                }
            } else {
                return {
                    ...prev,
                    option: e.target.value,
                }
            }
        })
    }
    return (
        <div>
            <div>
                <label className="block mb-2 text-sm font-medium text-white">Option {label}</label>
                <span className="block mb-2 text-[12px]">Check checkbox if this option is correct</span>
            </div>
            <div className='flex items-center gap-2'>
                <input type="text" name='option' className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                    value={option.option}
                    onChange={changeHandler}
                />
                <label className="inline-flex items-center">
                    <input type="checkbox" name="isCorrect" className="form-checkbox h-9 w-9 text-green-500 transition duration-150 ease-in-out rounded-full focus:outline-none"
                        checked={option.isCorrect}
                        onChange={changeHandler}
                    />
                </label>
            </div>
        </div>
    )
};